import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="weather-header">
      <div className="header-content">
        <h3>🌍 WeatherNow: Live Weather | City Forecast | Global Conditions</h3>
      </div>
    </header>
  );
};

export default Header;
